<ngx-loading [show]="loading"></ngx-loading>
<div class="modal-header border-0 p-0">
  <button
    type="button"
    class="btn white-font p-0 ml-auto mr-2"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <i class="fal fa-times"></i>
  </button>
</div>

<div class="p-3">
  <div class="center" *ngIf="consultationFileType === ConsultationFileType.Transcript">
    <h5 class="text-uppercase navy-font text-center mt-0 mb-3">Consultation Transcript</h5>
    <kendo-textarea
      class="my-2"
      placeholder="Consult Transcription"
      [readonly]="true"
      [rows]="15"
      [(ngModel)]="transcription"
    ></kendo-textarea>
  </div>
  <div class="center" *ngIf="consultationFileType === ConsultationFileType.Audio">
    <h6 class="text-uppercase navy-font text-center mt-0 mb-3">
      {{ noteAudioType === NoteAudioType.Consultation ? 'Consultation' : 'Dictation' }} Audio
    </h6>
    <audio controls>
      <source [src]="base64AudioSrc" />
      Your browser does not support the audio element.
    </audio>
  </div>
  <div class="mt-3 text-center">
    <button class="btn em-btn em-btn-green ml-2" (click)="activeModal.dismiss('Close click')">Close</button>
  </div>
</div>
